export const triggerPointsAction = `mutation TriggerPointsAction($companyId: ID!, $input: PointsTriggerCustomActionInput!) {
  triggerPointsAction(companyId: $companyId, input: $input) {
    eventIds
    failedUserIds
    failureReasons
    eventsCreated
    success
  }
}
`;
